import Login from "../../Components/Login";
import './LoginPage.css'
const LoginPage: React.FC = () => (
   
    <Login/>
);

export default LoginPage;